// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {BizumModalProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';
import {containerTemplate, EVENT} from './container';

const options: ComponentOptionsType<BizumModalProps> = {
  tag: 'monei-bizum',
  url: config.bizumUrl,
  dimensions: {
    width: '100%',
    height: '100%'
  },
  autoResize: {
    width: false,
    height: false
  },
  prerenderTemplate: () => undefined,
  containerTemplate: containerTemplate,
  props: {
    accountId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    sessionId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    amount: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    currency: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    transactionType: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    phoneNumber: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    isHidden: {
      type: zoid.PROP_TYPE.BOOLEAN,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onSubmit: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onBeforeClose: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      default: ({event}: any) => {
        return () => {
          event.trigger(EVENT.BEFORE_CLOSE);
        };
      }
    }
  },
  exports: {
    setPhoneNumber: {
      type: 'function'
    },
    getPhoneNumber: {
      type: 'function'
    }
  }
};

export const BizumModal: MoneiComponent<BizumModalProps> = zoid.create(options);
